import { render } from "./workspaces.vue?vue&type=template&id=5492e5da&scoped=true"
import script from "./workspaces.vue?vue&type=script&lang=js"
export * from "./workspaces.vue?vue&type=script&lang=js"

import "./workspaces.vue?vue&type=style&index=0&id=5492e5da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5492e5da"]])

export default __exports__